import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';
import SimpleCurrencyInput from '../../../common/SimpleCurrencyInput';

const PreferredTip = ({ disabled, value, onChange }) => (
  <div className="layout__item u-1/3-medium-and-up u-pl0 u--mt-">
    <div className="c-label-new">{t('appointment:form.preferred_tip_label')}</div>
    <SimpleCurrencyInput
      className="c-input c-input--prepend"
      disabled={disabled}
      value={value}
      onInputChange={onChange}
      type="number"
      addPrefix
    />
  </div>
);
PreferredTip.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

PreferredTip.defaultProps = {
  disabled: false,
};

export default PreferredTip;
